<template>
	<div>
		<el-card class="box-card">
			<div class="card-header">
				<el-form :label-width="200">
					<el-form-item :label="$t('group.select_device')" prop="imei">
						<el-input readonly v-model="imei" />
						<el-button @click="addDevice" type="primary">{{ $t('device.add') }}</el-button>
						<el-button @click="delDevice" type="primary">{{ $t('device.delete') }}</el-button>
					</el-form-item>
					<el-form-item :label="$t('index.clock_content')">
						<el-input :placeholder="$t('notice.input_message')" type="textarea" :rows="6"
							:show-word-limit="true" :maxlength="15" v-model="clock_content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('index.clock_time')">
            <!-- 时间选择器 -->
            <div class="time-picker">
              <el-select v-model="selectedHour" placeholder="时" class="time-select">
                <el-option v-for="h in hours" :key="h" :label="h" :value="h"></el-option>
              </el-select>
              <span class="time-colon">:</span>
              <el-select v-model="selectedMinute" placeholder="分" class="time-select">
                <el-option v-for="m in minutes" :key="m" :label="m" :value="m"></el-option>
              </el-select>
            </div>
					</el-form-item>
					<el-form-item :label="$t('index.clock_cycle')">
            <!-- 周期选择器 -->
            <el-checkbox-group v-model="selectedDays">
              <el-checkbox 
                v-for="day in weekDays" 
                :key="day.value" 
                :label="day.value"
              >
                {{ day.label }}
              </el-checkbox>
            </el-checkbox-group>
					</el-form-item>
					<el-form-item>
						<el-button @click="handleSubmit" type="primary">{{ $t('notice.submit') }}</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-card>

		<!-- 设备选择对话框 -->
		<el-dialog :title="dialogTit" center v-model="addDialog" width="70%">
			<div style="padding-bottom:60px;">
				<el-form :model="addform" :inline="true" ref="searchForm">
					<el-form-item label="IMEI" prop="imei_keyword">
						<el-input :placeholder="$t('notice.enter_imei')" v-model="addform.imei_keyword"></el-input>
					</el-form-item>
					<el-form-item :label="$t('device.bind_name')" prop="name">
						<el-input v-model="addform.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('index.device_type')" prop="type">
						<el-select clearable :placeholder="$t('index.device_type')" v-model="addform.type">
							<el-option :key="item.value" :label="item.text" :value="item.value"
								v-for="item in deviceType"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('device.device_status')" prop="online">
						<el-select :placeholder="$t('device.device_status')" v-model="addform.online">
							<el-option :label="$t('index.online')" value="1"></el-option>
							<el-option :label="$t('index.offline')" value="0"></el-option>
							<el-option :label="$t('index.stripping_outline')" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('device.vesting')" prop="client_id">
						<el-cascader :options="clientData" :placeholder="$t('device.vesting')"
							v-model="addform.client_id"></el-cascader>
					</el-form-item>
					<el-form-item>
						<el-button @click="addSearch" type="primary">{{ $t('device.inquire') }}</el-button>
						<el-button @click="resetSearch">{{ $t('device.reset') }}</el-button>
						<el-button @click="handleAddDevice" type="primary">{{ $t('group.save') }}</el-button>
					</el-form-item>
				</el-form>
				<el-table :data="deviceData" @select="handleSelect" @select-all="handleSelectAll" ref="deviceTable">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column :label="$t('index.device')" property="imei" width="150"></el-table-column>
					<el-table-column :label="$t('index.device_type')" property="type"></el-table-column>
					<el-table-column :label="$t('device.device_status')" property="online"></el-table-column>
					<el-table-column :label="$t('device.bind_name')" property="name"></el-table-column>
					<el-table-column :label="$t('device.creation_time')" property="create_at"></el-table-column>
				</el-table>
				<el-pagination :page-size="addform.size" :total="addCount" @current-change="handleDeviceCurrentChange"
					@size-change="handleDeviceSizeChange" layout="total, prev, pager, next, jumper"></el-pagination>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import device from "../../model/device";
	import client from "../../model/client";

	export default {
		name: "notice",
		data() {
			return {
				imei: '',
				clock_content: '',
				// 时间选择相关
				selectedHour: '08',
				selectedMinute: '00',
				hours: Array.from({length: 24}, (_, i) => i.toString().padStart(2, '0')),
				minutes: Array.from({length: 60}, (_, i) => i.toString().padStart(2, '0')),
				// 周期选择相关
				selectedDays: [],
				weekDays: [
					{ label: this.$t('device.monday'), value: 1 },
					{ label: this.$t('device.tuesday'), value: 2 },
					{ label: this.$t('device.wednesday'), value: 3 },
					{ label: this.$t('device.thursday'), value: 4 },
					{ label: this.$t('device.friday'), value: 5 },
					{ label: this.$t('device.saturday'), value: 6 },
					{ label: this.$t('device.sunday'), value: 7 }
				],
				// 设备选择相关数据
				addform: {
					imei: "",
					name: "",
					imei_keyword: "",
					type: "",
					online: "",
					client_id: "",
					page: 1,
					size: 6
				},
				addCount: 0,
				addDialog: false,
				dialogTit: this.$t('group.add_device'),
				deviceType: [],
				deviceData: [],
				clientData: [],
				selectDevice: []
			}
		},
		async mounted() {
			await this.clientList();
			await this.deviceTypeArr();
		},
		methods: {
			async clientList() {
				const ret = await client.list();
				if (ret.code === 200) {
					this.clientData = this.handleClientTree(ret.data)
				}
			},
			handleClientTree(data) {
				if (data.length === 0) {
					return []
				}
				let options = []
				data.forEach(item => {
					options.push({
						value: item.id,
						label: item.name
					})
					if (item.children.length > 0) {
						options.push({
							value: item.id,
							label: item.name,
							children: this.handleClientTree(item.children)
						})
					}
				})
				return options
			},
			async deviceTypeArr() {
				const ret = await device.config();
				if (ret.code === 200) {
					this.deviceType = ret.data;
				}
			},
			async deviceList() {
				const ret = await device.group(this.addform);
				if (ret.code === 200) {
					this.deviceData = ret.data.list;
					this.addCount = ret.data.count;
					setTimeout(() => {
						this.deviceData.forEach(v => {
							this.$refs.deviceTable.toggleRowSelection(
								v,
								this.selectDevice.indexOf(v.imei) > -1
							);
						});
					});
				}
			},
			addDevice() {
				this.addDialog = true;
				this.dialogTit = this.$t('group.add_device');
				this.selectDevice = this.imei ? this.imei.split(',') : [];
				this.addform.imei = "";
				this.addform.imei_keyword = "";
				this.deviceList();
			},
			delDevice() {
				this.addDialog = true;
				this.dialogTit = this.$t('group.delete_device');
				this.selectDevice = this.imei ? this.imei.split(',') : [];
				this.addform.imei_keyword = ''
				this.addform.imei = this.selectDevice.length == 0 ? [''] : this.selectDevice.join(",");
				this.deviceList();
			},
			handleAddDevice() {
				this.imei = this.selectDevice.join(",");
				this.addDialog = false;
			},
			handleSelect(selection, row) {
				const index = this.selectDevice.indexOf(row.imei);
				if (index > -1) {
					this.selectDevice.splice(index, 1);
				} else {
					this.selectDevice.push(row.imei);
				}
			},
			handleSelectAll(selection) {
				if (selection.length === 0) {
					this.deviceData.forEach(v => {
						let index = this.selectDevice.indexOf(v.imei);
						if (index > -1) {
							this.selectDevice.splice(index, 1);
						}
					})
				} else {
					this.deviceData.forEach(v => {
						let index = this.selectDevice.indexOf(v.imei);
						if (index < 0) {
							this.selectDevice.push(v.imei);
						}
					})
				}
			},
			addSearch() {
				this.deviceList();
			},
			resetSearch() {
				this.$refs.searchForm.resetFields();
				this.deviceList();
			},
			handleDeviceSizeChange(val) {
				this.addform.size = val;
				this.deviceList();
			},
			handleDeviceCurrentChange(val) {
				this.addform.page = val;
				this.deviceList();
			},
			async handleSubmit() {
				if(this.imei=='' || this.clock_content=='') {
					return;
				}
				if(this.selectedDays.length<1){
					return;
				}
				
				// 构建闹钟对象
				const alarm = {
					clock_content: this.clock_content,
					clock_time: `${this.selectedHour}:${this.selectedMinute}`,
					clock_cycle: this.selectedDays.sort((a, b) => a - b) // 排序确保顺序一致
				};
				
				// 转换为JSON字符串
				const content = JSON.stringify(alarm);
				
				const ret = await device.notice({
					type: 2,
					imei: this.imei,
					content: content
				})
				if (ret.code === 200) {
					this.imei = ''
					this.clock_content = ''
					this.selectedHour = '08'
					this.selectedMinute = '00'
					this.selectedDays = []
					this.$message.success(ret.message);

					this.toNoticeList();
				} else {
					this.$message.error(ret.message);
				}
			},
			toNoticeList() {
				this.$router.push({
					path: "/device/clockList"
				});
			}
		}
	};
</script>
<style scoped>
	.el-dialog::v-deep .el-dialog__body {
		padding-bottom: 100px !important;
	}

	.card-header .el-form-item__content {
		display: flex !important;
		align-items: flex-start;
	}

	.card-header .el-form-item__label {
		float: left;
	}

	.el-button {
		margin-left: 10px;
	}
  
  /* 时间选择器样式 */
  .time-picker {
    display: flex;
    align-items: center;
    flex: none;
    width: auto;
  }

  .time-select {
    width: 100px;
    flex: 0 0 100px;
  }

  .time-select .el-select__wrapper {
    width: 100%;
    min-height: 32px;
  }

  .time-colon {
    margin: 0 5px;
    flex: none;
  }
  
  /* 周期选择器样式 */
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
  }
  
  .el-checkbox {
    margin-right: 15px;
  }
</style>